import { schema } from "normalizr";

export const activityTailSchema = new schema.Entity("activityTails", {});

export const activityTailsSchema = new schema.Array(activityTailSchema);

export const masterClassSchema = new schema.Entity("masterClasses", {});

export const masterClasssSchema = new schema.Array(masterClassSchema);
